import React, { Component } from "react"
import { Container, Col, Button } from 'react-bootstrap'
import { connect } from "react-redux";
import SearchResultsDetailsNoResults from './SearchResultsDetailsNoResults'
import { LOADING_STATUES } from "../../constants/constants";
import Loading from '../../common/modal/Loading';
import Thumbnails from "../../image/Thumbnails";

const mapStateToProps = state => {
    return {
        searchResults: state.searchResultsReducer,
        searchResultsDetails: state.searchDetailsGrantorGranteeBookReducer,
        currentUser: state.currentUserReducer
    };
}

class GrantorGranteeBookSearchResultsDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imagingWindows: this.createImagingWindowsWindowState('', false),
            loadingStatus: ""
        };
    }

    showLoading = () => {
        if (this.state.loadingStatus === "") {
          this.setState({
            loadingStatus: LOADING_STATUES.LOADING
          })
          return true;
        } 
        return false;
      }

    hideLoading = (message, status) => {
          this.setState({
            loadingStatus: ""
          })
     }

    // May return null if not found.
    getSelectedSearchResult = () => {
        if (!this.props.searchResults || (this.props.searchResultsDetails === 0)) {
            return null;
        }

        let searchResult = this.props.searchResults.searchResultList.find((searchResult) => {
            return this.props.searchResultsDetails == searchResult.sourcedDocKey.docKeyNumber;
        });

        return searchResult;
    }

    // Can return null.
    getSelectedSearchResultInfo = () => {
        let searchResult = this.getSelectedSearchResult();

        if (!searchResult) {
            return null;
        }

		let info = { 
            sourcedDocKey: searchResult.sourcedDocKey,
            instrumentCode: ''      // there is none for this doc type
        };

        return info;
    }

    handleImageClick = (event) => {
        if (event) {
            event.preventDefault();
         }
           
        let info = this.getSelectedSearchResultInfo();

        if (!info) {
            alert("Select a document.");
            return; 
        }

        this.setState( {
            imagingWindows: this.createImagingWindowsWindowState(info, true)
        } );
    }

    handleImageComplete = () => {
        this.setState( {
            imagingWindows: this.createImagingWindowsWindowState(null, false)
        } );
    }

    createImagingWindowsWindowState = (searchResult, show) => {
        return {
            sourcedDocKey: searchResult ? searchResult.sourcedDocKey : {},
            instCode: searchResult ? searchResult.instrumentCode : '',
            show: show
        }
    }
    
    render() {
        let selectedSearchResult = this.getSelectedSearchResult();

        if (!selectedSearchResult) {
            return (<SearchResultsDetailsNoResults />)
        }

        let { type, fromName, toName, fromDate, toDate } = selectedSearchResult;
        let imageKeyType = selectedSearchResult.sourcedDocKey.imageKeyType;

        return (
            <Col style={{ paddingLeft: 0, marginRight: 0, boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }} >
                <Container key={this.props.searchResultsDetails} style={{ paddingLeft: 10, paddingTop: 10, paddingRight: 0, paddingBottom: 10, marginRight: 0 }}  fluid="true">
                    <div>
                        <h5 >
                            <strong>{type}</strong>
                            <span style={{ float: 'right' }}>
                                {
                                    this.props.currentUser.accountDocTypes[imageKeyType].imageRetrieval &&
                                    <Button variant="primary" size="sm" onClick={this.handleImageClick} >Image</Button>
                                }
                            </span>
                        </h5>
                    </div>
                    <hr style={{ background: 'black', marginTop: 2, marginBottom: 2 }}></hr>
                    <div style={{ marginBottom: 0, marginTop: 10 }} >
                        <div><strong>Book Reference #: </strong>{selectedSearchResult.sourcedDocKey.docKeyNumber} &nbsp;</div>
                        <div><strong>Name: </strong>{fromName} - {toName}</div>
                        <div><strong>Date: </strong>{fromDate} - {toDate}</div>
                    </div>
                </Container>
                <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
                <Thumbnails show={this.state.imagingWindows.show} 
                    sourcedDocKey={this.state.imagingWindows.sourcedDocKey} 
                    instCode={this.state.imagingWindows.instCode} 
                    complete={this.handleImageComplete} />
            </Col>
        )
    }
}

export default connect(mapStateToProps)(GrantorGranteeBookSearchResultsDetails);